import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgFor } from '@angular/common';
import { NgIf } from '@angular/common';
import { NgxPrintModule } from 'ngx-print';
@Component({
  selector: 'app-view-from',
  standalone: true,
  imports: [CommonModule, NgFor, NgIf, NgxPrintModule],
  template: `
    <div  class="bg-white rounded-xl border border-slate-200  overflow-hidden print:shadow-none print:border-none">
      <div class="flex flex-col">
        <ng-container *ngFor="let item of keys">
          
          <div *ngIf="!item.key" 
               class="bg-slate-50 px-4 py-2 border-y border-slate-200 first:border-t-0">
            <h3 class="text-[11px] font-bold uppercase tracking-wider text-slate-500">
              {{ item.label }}
            </h3>
          </div>

          <div *ngIf="item.key" 
               class="grid grid-cols-12 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/50 transition-colors">
            
            <div class="col-span-4 bg-slate-50/30 px-4 py-2.5 border-r border-slate-100 flex items-start">
              <span class="text-[12px] font-semibold text-slate-600">
                {{ item.label }}
              </span>
            </div>

            <div class="col-span-8 px-4 py-2.5 bg-white min-h-[40px]">
              <div class="text-[13px] text-slate-800 leading-relaxed">
                <ng-container *ngIf="checkIsHtml(getNestedValue(data, item.key)); else plainText">
                  <div class="prose prose-sm max-w-none prose-slate" 
                       [innerHTML]="getNestedValue(data, item.key)">
                  </div>
                </ng-container>
                <ng-template #plainText>
                  <span class="font-medium">
                    {{ getNestedValue(data, item.key) || '-' }}
                  </span>
                </ng-template>
              </div>
            </div>

          </div>
        </ng-container>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    @media print {
      #printSection { border: 1px solid #e2e8f0 !important; }
      .bg-slate-50\/30 { background-color: #f8fafc !important; -webkit-print-color-adjust: exact; }
    }
  `]
})
export class ViewFromComponent  {
    @Input() data: any;
    @Input() keys: any;
    
 
  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((o, key) => (o && o[key] !== undefined) ? o[key] : '', obj);
  }
    checkIsHtml(value: any): boolean {
    if (typeof value !== 'string') {
      return false;
    }
    const trimmed = value.trim();
    if (!trimmed) {
      return false;
    }
      const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
  
    const result = htmlTagRegex.test(trimmed);
    return result;
  }
}